import React, { Fragment } from 'react'
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Box from '@mui/material/Box';
import { useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { v4 as uuidv4 } from 'uuid';
import SolicitudesACComponent from './SolicitudesACComponent';
import { obtenerSolicitudesACDireccion } from '../../../redux/DuckDireccionGerente/DireccionGerenteDuck';

function TabsSolicitudesAtendidasACComponent(props) {

    const dispatch = useDispatch()
    //const solicitudes = useSelector(store => store.EstatusSolicitudesUIF01.estatusSolicitudesAC)

    const [tabSolicitudes, setTabSolicitudes] = React.useState('estatus2');
    const [solicitudes, setSolicitudes] = React.useState();
    const solicitudesEstatus = []
    const [openModalRevisor, setOpenModalRevisor] = React.useState(false);


    React.useEffect(async () => {
        if (tabSolicitudes == 'estatus2') {
            let resEstatus2 = await dispatch(obtenerSolicitudesACDireccion(2))
            setSolicitudes(resEstatus2?.payload)
        }
        if (tabSolicitudes == 'estatus3') {
            let resEstatus3 = await dispatch(obtenerSolicitudesACDireccion(3))
            setSolicitudes(resEstatus3?.payload)
        }
        if (tabSolicitudes == 'estatus4') {
            let resEstatus4 = await dispatch(obtenerSolicitudesACDireccion(4))
            setSolicitudes(resEstatus4?.payload)
        }
        if (tabSolicitudes == 'estatus5') {
            let resEstatus5 = await dispatch(obtenerSolicitudesACDireccion(5))
            setSolicitudes(resEstatus5?.payload)
        }
        if (tabSolicitudes == 'estatus6') {
            let resEstatus6 = await dispatch(obtenerSolicitudesACDireccion(6))
            setSolicitudes(resEstatus6?.payload)
        }
    }, [tabSolicitudes, openModalRevisor])


    const handleChangeSolicitudesTab = (event, newValue) => {
        setTabSolicitudes(newValue);
    };

    solicitudes?.fc_01_solicitudderegistro?.map(solicitud => {
        let fecha = solicitud.fechasolicitud.substring(0, 10)

        let nombre = solicitud.revisor?.split(' ')
        let revisor = ''
        if (nombre === undefined) revisor = ''
        else if (nombre.length === 4) revisor = nombre[0] + ' ' + nombre[2]
        else revisor = nombre[0] + ' ' + nombre[1]

        let estatus = ''
        if (solicitud?.idestatusdesolicitudes == 2) estatus = 'Recibida en AC'
        if (solicitud?.idestatusdesolicitudes == 3) estatus = 'En Revisión Por AC'
        if (solicitud?.idestatusdesolicitudes == 4) estatus = 'Aceptada Por AC'
        if (solicitud?.idestatusdesolicitudes == 5) estatus = 'Devuelta al cliente para corrección'
        if (solicitud?.idestatusdesolicitudes == 6) estatus = 'Recibida corregida por el cliente'

        let folio = ''
        /*if(solicitud?.idestatusdesolicitudes != 4)*/folio = solicitud.folio
        //else folio= solicitud?.informacionmodalaceptada?.numerosolicitudservicios

        solicitudesEstatus.push({
            id: uuidv4(), idSolicitud: solicitud.idfc01_solicitudregistro, folio: folio,
            noSocio: solicitud.numerosocio !== undefined ? solicitud.numerosocio?.toString().length > 0 ? solicitud.numerosocio : '' : '',
            FechaDecreación: fecha, tipoSolicitud: 'Solicitud de inscripción', nombreRazon: solicitud.nombrerazonsocial,
            Nombre: 'fc_01_solicitudderegistro', idlogin: solicitud.idlogin, Revisor: nombre?.[0] !== undefined ? revisor : '',
            estatus: estatus,
        })
    })
    solicitudes?.fc_05_solicitudusomarcaeimagen?.map(solicitud => {
        let fecha = solicitud.fechasolicitud.substring(0, 10)
        let nombre = solicitud.revisor?.split(' ')
        let revisor = ''
        if (nombre === undefined) revisor = ''
        else if (nombre.length === 4) revisor = nombre[0] + ' ' + nombre[2]
        else revisor = nombre[0] + ' ' + nombre[1]
        let estatus = ''
        if (solicitud?.idestatusdesolicitudes == 2) estatus = 'Recibida en AC'
        if (solicitud?.idestatusdesolicitudes == 3) estatus = 'En Revisión Por AC'
        if (solicitud?.idestatusdesolicitudes == 4) estatus = 'Aceptada Por AC'
        if (solicitud?.idestatusdesolicitudes == 5) estatus = 'Devuelta al cliente para corrección'
        if (solicitud?.idestatusdesolicitudes == 6) estatus = 'Recibida corregida por el cliente'

        solicitudesEstatus.push({
            id: uuidv4(), folio: solicitud.folio, idSolicitud: solicitud.idfc05_solicitudusomarcaeimagen, FechaDecreación: fecha,
            tipoSolicitud: 'Solicitud de uso marca e imagen COMERCAM', nombreRazon: solicitud.nombrerazonsocial,
            noSocio: solicitud.numerocliente, Nombre: 'fc_05_solicitudusomarcaeimagen',
            idlogin: solicitud.idlogin, Revisor: nombre?.[0] !== undefined ? revisor : '', estatus: estatus,
        })
    })
    solicitudes?.fc_06_registrodemaguey?.map(solicitud => {
        let fecha = solicitud.fechasolicitud.substring(0, 10)
        let nombre = solicitud.revisor?.split(' ')
        let revisor = ''
        if (nombre === undefined) revisor = ''
        else if (nombre.length === 4) revisor = nombre[0] + ' ' + nombre[2]
        else revisor = nombre[0] + ' ' + nombre[1]
        let estatus = ''
        if (solicitud?.idestatusdesolicitudes == 2) estatus = 'Recibida en AC'
        if (solicitud?.idestatusdesolicitudes == 3) estatus = 'En Revisión Por AC'
        if (solicitud?.idestatusdesolicitudes == 4) estatus = 'Aceptada Por AC'
        if (solicitud?.idestatusdesolicitudes == 5) estatus = 'Devuelta al cliente para corrección'
        if (solicitud?.idestatusdesolicitudes == 6) estatus = 'Recibida corregida por el cliente'

        solicitudesEstatus.push({
            id: uuidv4(), folio: solicitud.folio, idSolicitud: solicitud.idfc06_registromaguey, FechaDecreación: fecha,
            tipoSolicitud: 'Solicitud de registro de maguey', nombreRazon: solicitud.nombrerazonsocial,
            noSocio: solicitud.numerocliente, Nombre: 'fc_06_registrodemaguey',
            idlogin: solicitud.idlogin, Revisor: nombre?.[0] !== undefined ? revisor : '', estatus: estatus,
        })
    })
    solicitudes?.fc_08_solicitudrenvacioncertificados?.map(solicitud => {
        let fecha = solicitud.fechasolicitud.substring(0, 10)
        let nombre = solicitud.revisor?.split(' ')
        let revisor = ''
        if (nombre === undefined) revisor = ''
        else if (nombre.length === 4) revisor = nombre[0] + ' ' + nombre[2]
        else revisor = nombre[0] + ' ' + nombre[1]
        let estatus = ''
        if (solicitud?.idestatusdesolicitudes == 2) estatus = 'Recibida en AC'
        if (solicitud?.idestatusdesolicitudes == 3) estatus = 'En Revisión Por AC'
        if (solicitud?.idestatusdesolicitudes == 4) estatus = 'Aceptada Por AC'
        if (solicitud?.idestatusdesolicitudes == 5) estatus = 'Devuelta al cliente para corrección'
        if (solicitud?.idestatusdesolicitudes == 6) estatus = 'Recibida corregida por el cliente'
        solicitudesEstatus.push({
            id: uuidv4(), folio: solicitud.folio, idSolicitud: solicitud.idfc08_renvacioncertificado, FechaDecreación: fecha,
            tipoSolicitud: 'Solicitud de renovación de certificados', nombreRazon: solicitud.nombrerazonsocial,
            noSocio: solicitud.numerocliente, Nombre: 'fc_08_solicitudrenvacioncertificados',
            idlogin: solicitud.idlogin, Revisor: nombre?.[0] !== undefined ? revisor : '', estatus: estatus
        })
    })
    solicitudes?.fc_09_solicitudemicioncertificadonomexportacionyentregahologram?.map(solicitud => {
        let fecha = solicitud.fechasolicitud.substring(0, 10)
        let nombre = solicitud.revisor?.split(' ')
        let revisor = ''
        if (nombre === undefined) revisor = ''
        else if (nombre.length === 4) revisor = nombre[0] + ' ' + nombre[2]
        else revisor = nombre[0] + ' ' + nombre[1]

        let estatus = ''
        if (solicitud?.idestatusdesolicitudes == 2) estatus = 'Recibida en AC'
        if (solicitud?.idestatusdesolicitudes == 3) estatus = 'En Revisión Por AC'
        if (solicitud?.idestatusdesolicitudes == 4) estatus = 'Aceptada Por AC'
        if (solicitud?.idestatusdesolicitudes == 5) estatus = 'Devuelta al cliente para corrección'
        if (solicitud?.idestatusdesolicitudes == 6) estatus = 'Recibida corregida por el cliente'

        solicitudesEstatus.push({
            id: uuidv4(), folio: solicitud.folio, idSolicitud: solicitud.idfc09_solicitudcertificado, FechaDecreación: fecha,
            tipoSolicitud: 'Solicitud de certificado NOM para exportación', nombreRazon: solicitud.nombrecliente,
            noSocio: solicitud.numerocliente, Nombre: 'fc_09_solicitudemicioncertificadonomexportacionyentregahologram',
            idlogin: solicitud.idlogin, Revisor: nombre?.[0] !== undefined ? revisor : '', estatus: estatus
        })
    })
    solicitudes?.fc_30_notificaciontrasladodeproducto?.map(solicitud => {
        let fecha = solicitud.fechasolicitud.substring(0, 10)
        let nombre = solicitud.revisor?.split(' ')
        let revisor = ''
        if (nombre === undefined) revisor = ''
        else if (nombre.length === 4) revisor = nombre[0] + ' ' + nombre[2]
        else revisor = nombre[0] + ' ' + nombre[1]
        let estatus = ''
        if (solicitud?.idestatusdesolicitudes == 2) estatus = 'Recibida en AC'
        if (solicitud?.idestatusdesolicitudes == 3) estatus = 'En Revisión Por AC'
        if (solicitud?.idestatusdesolicitudes == 4) estatus = 'Aceptada Por AC'
        if (solicitud?.idestatusdesolicitudes == 5) estatus = 'Devuelta al cliente para corrección'
        if (solicitud?.idestatusdesolicitudes == 6) estatus = 'Recibida corregida por el cliente'
        solicitudesEstatus.push({
            id: uuidv4(), idSolicitud: solicitud.idfc30_notificaciontrasladodepr, FechaDecreación: fecha,
            folio: solicitud.folio, tipoSolicitud: 'Solicitud de traslado de producto', noSocio: solicitud.numerocliente,
            nombreRazon: solicitud.nombrecliente, idlogin: solicitud.idlogin, Revisor: nombre?.[0] !== undefined ? revisor : '',
            Nombre: 'fc_30_notificaciontrasladodeproducto', idlogin: solicitud.idlogin, uri: 'FC_30/obtenerFormatoFC30/',
            estatus: estatus
        })
    })
    solicitudes?.fc_31_solicitudseguimiento?.map(solicitud => {
        let fecha = solicitud.fechasolicitud.substring(0, 10)
        let nombre = solicitud.revisor?.split(' ')
        let revisor = ''
        if (nombre === undefined) revisor = ''
        else if (nombre.length === 4) revisor = nombre[0] + ' ' + nombre[2]
        else revisor = nombre[0] + ' ' + nombre[1]

        let estatus = ''
        if (solicitud?.idestatusdesolicitudes == 2) estatus = 'Recibida en AC'
        if (solicitud?.idestatusdesolicitudes == 3) estatus = 'En Revisión Por AC'
        if (solicitud?.idestatusdesolicitudes == 4) estatus = 'Aceptada Por AC'
        if (solicitud?.idestatusdesolicitudes == 5) estatus = 'Devuelta al cliente para corrección'
        if (solicitud?.idestatusdesolicitudes == 6) estatus = 'Recibida corregida por el cliente'
        solicitudesEstatus.push({
            id: uuidv4(), idSolicitud: solicitud.idfc31_solicitudseguimiento, FechaDecreación: fecha,
            folio: solicitud.folio, tipoSolicitud: 'Solicitud de seguimiento', noSocio: solicitud.numerocliente,
            nombreRazon: solicitud.nombrerazonsocial, idlogin: solicitud.idlogin, Revisor: nombre?.[0] !== undefined ? revisor : '',
            Nombre: 'fc_31_solicitudseguimiento', idlogin: solicitud.idlogin, uri: 'FC_31/obtenerFormatoFC31/', estatus: estatus
        })
    })
    solicitudes?.fc_33_solicitudenvasadonacional?.map(solicitud => {
        let revisor = ''
        let nombre = solicitud.revisor?.split(' ')
        if (nombre === undefined) revisor = ''
        else if (nombre.length === 4) revisor = nombre[0] + ' ' + nombre[2]
        else revisor = nombre[0] + ' ' + nombre[1]
        let estatus = ''
        if (solicitud?.idestatusdesolicitudes == 2) estatus = 'Recibida en AC'
        if (solicitud?.idestatusdesolicitudes == 3) estatus = 'En Revisión Por AC'
        if (solicitud?.idestatusdesolicitudes == 4) estatus = 'Aceptada Por AC'
        if (solicitud?.idestatusdesolicitudes == 5) estatus = 'Devuelta al cliente para corrección'
        if (solicitud?.idestatusdesolicitudes == 6) estatus = 'Recibida corregida por el cliente'
        solicitudesEstatus.push({
            id: uuidv4(), idSolicitud: solicitud.idfc33_solicitudenvasadonaciona, folio: solicitud.folio, FechaDecreación: solicitud.fechasolicitud.substring(0, 10),
            idlogin: solicitud.idlogin, tipoSolicitud: 'Solicitud de venta nacional', Revisor: nombre?.[0] !== undefined ? revisor : '',
            nombreRazon: solicitud.nombrecliente, noSocio: solicitud.numerocliente, estatus: estatus
        })
    })
    solicitudes?.fc_34_notificacionsuspencionyreactivacion?.map(solicitud => {
        let revisor = ''
        let nombre = solicitud.revisor?.split(' ')
        if (nombre === undefined) revisor = ''
        else if (nombre.length === 4) revisor = nombre[0] + ' ' + nombre[2]
        else revisor = nombre[0] + ' ' + nombre[1]
        let estatus = ''
        if (solicitud?.idestatusdesolicitudes == 2) estatus = 'Recibida en AC'
        if (solicitud?.idestatusdesolicitudes == 3) estatus = 'En Revisión Por AC'
        if (solicitud?.idestatusdesolicitudes == 4) estatus = 'Aceptada Por AC'
        if (solicitud?.idestatusdesolicitudes == 5) estatus = 'Devuelta al cliente para corrección'
        if (solicitud?.idestatusdesolicitudes == 6) estatus = 'Recibida corregida por el cliente'
        solicitudesEstatus.push({
            id: uuidv4(), idSolicitud: solicitud.idfc34_notificacionsuspencion,
            folio: solicitud.folio, FechaDecreación: solicitud.fechasolicitud.substring(0, 10),
            tipoSolicitud: 'Notificación suspensión y reactivación', Revisor: nombre?.[0] !== undefined ? revisor : '',
            Nombre: 'fc_34_notificacionsuspencionyreactivacion',
            idlogin: solicitud.idlogin, nombreRazon: solicitud.nombrerazonsocial, noSocio: solicitud.numerocliente,
            estatus: estatus
        })
    })
    solicitudes?.fc_35_notificaciondeserviciosvarios?.map(solicitud => {
        let fecha = solicitud.fechasolicitud.substring(0, 10)
        let nombre = solicitud.revisor?.split(' ')
        let revisor = ''
        if (nombre === undefined) revisor = ''
        else if (nombre.length === 4) revisor = nombre[0] + ' ' + nombre[2]
        else revisor = nombre[0] + ' ' + nombre[1]
        let estatus = ''
        if (solicitud?.idestatusdesolicitudes == 2) estatus = 'Recibida en AC'
        if (solicitud?.idestatusdesolicitudes == 3) estatus = 'En Revisión Por AC'
        if (solicitud?.idestatusdesolicitudes == 4) estatus = 'Aceptada Por AC'
        if (solicitud?.idestatusdesolicitudes == 5) estatus = 'Devuelta al cliente para corrección'
        if (solicitud?.idestatusdesolicitudes == 6) estatus = 'Recibida corregida por el cliente'
        solicitudesEstatus.push({
            id: uuidv4(), idSolicitud: solicitud.idfc35_notificacionserviciosvar,
            folio: solicitud.folio, tipoSolicitud: 'Solicitud de servicios varios', noSocio: solicitud.numerocliente,
            FechaDecreación: fecha, Nombre: 'fc_35_notificaciondeserviciosvarios',
            idlogin: solicitud.idlogin, nombreRazon: solicitud.nombrerazonsocial,
            Revisor: nombre?.[0] !== undefined ? revisor : '', estatus: estatus
        })
    })
    solicitudes?.fc_36_solicituddeactualizacion?.map(solicitud => {
        let fecha = solicitud.fechasolicitud.substring(0, 10)
        let nombre = solicitud.revisor?.split(' ')
        let revisor = ''
        if (nombre === undefined) revisor = ''
        else if (nombre.length === 4) revisor = nombre[0] + ' ' + nombre[2]
        else revisor = nombre[0] + ' ' + nombre[1]

        let accion = ''
        if (solicitud.cambiorazon) accion = 'Cambio de razón social o régimen fiscal'
        else {
            if (solicitud.actualizaciondomicilio) accion = 'Actualización de domicilio fiscal'
            if (solicitud.cambioresponsable) accion = 'Actualización de persona autorizada para trámite'
            if (solicitud.cambiorepresentante) accion = 'Actualización de representante legal'
            if (solicitud.actualizarmedioscontacto) accion = 'Actualización medios de contacto'
            if (solicitud.actualizacioncadena) accion = 'Actualización de cadena productiva'
            if (solicitud.cambioresponsableinst) accion = 'Actualización de responsables de instalaciones'
            if (solicitud.actualizacioninstalaciones) accion = 'Alta o baja instalaciones'
            if (solicitud.actualizacionprediosviveros) accion = 'Baja predios/viveros'
            if (solicitud.actualizarmarcas) accion = 'Actualización de marcas'
        }

        let estatus = ''
        if (solicitud?.idestatusdesolicitudes == 2) estatus = 'Recibida en AC'
        if (solicitud?.idestatusdesolicitudes == 3) estatus = 'En Revisión Por AC'
        if (solicitud?.idestatusdesolicitudes == 4) estatus = 'Aceptada Por AC'
        if (solicitud?.idestatusdesolicitudes == 5) estatus = 'Devuelta al cliente para corrección'
        if (solicitud?.idestatusdesolicitudes == 6) estatus = 'Recibida corregida por el cliente'

        solicitudesEstatus.push({
            id: uuidv4(), idSolicitud: solicitud.idfc36_solicitudactualizacion,
            folio: solicitud.folio, tipoSolicitud: 'Solicitud de actualización: ' + accion, noSocio: solicitud.numerocliente,
            FechaDecreación: fecha, idlogin: solicitud.idlogin, nombreRazon: solicitud.nombrerazonsocial,
            Revisor: nombre?.[0] !== undefined ? revisor : '', estatus: estatus, tipo: 'Solicitud de actualización'
        })
    })
    solicitudes?.fc_40_solicituddeadquisiciondehologramas?.map(solicitud => {
        let fecha = solicitud.fechasolicitud.substring(0, 10)
        let nombre = solicitud.revisor?.split(' ')
        let revisor = ''
        if (nombre === undefined) revisor = ''
        else if (nombre.length === 4) revisor = nombre[0] + ' ' + nombre[2]
        else revisor = nombre[0] + ' ' + nombre[1]
        let estatus = ''
        if (solicitud?.idestatusdesolicitudes == 2) estatus = 'Recibida en AC'
        if (solicitud?.idestatusdesolicitudes == 3) estatus = 'En Revisión Por AC'
        if (solicitud?.idestatusdesolicitudes == 4) estatus = 'Aceptada Por AC'
        if (solicitud?.idestatusdesolicitudes == 5) estatus = 'Devuelta al cliente para corrección'
        if (solicitud?.idestatusdesolicitudes == 6) estatus = 'Recibida corregida por el cliente'
        solicitudesEstatus.push({
            id: uuidv4(), idSolicitud: solicitud.idfc40_solicitudadquisicionholo,
            folio: solicitud.folio, tipoSolicitud: 'Solicitud de compra de hologramas', noSocio: solicitud.numerocliente,
            FechaDecreación: fecha, Nombre: 'fc_40_solicituddeadquisiciondehologramas',
            idlogin: solicitud.idlogin, nombreRazon: solicitud.nombrerazonsocial,
            Revisor: nombre?.[0] !== undefined ? revisor : '', estatus: estatus
        })

    })
    solicitudes?.fc_41_solicitudparabebidasconmezcal?.map(solicitud => {
        let fecha = solicitud.fechasolicitud.substring(0, 10)
        let nombre = solicitud.revisor?.split(' ')
        let revisor = ''
        if (nombre === undefined) revisor = ''
        else if (nombre.length === 4) revisor = nombre[0] + ' ' + nombre[2]
        else revisor = nombre[0] + ' ' + nombre[1]

        let estatus = ''
        if (solicitud?.idestatusdesolicitudes == 2) estatus = 'Recibida en AC'
        if (solicitud?.idestatusdesolicitudes == 3) estatus = 'En Revisión Por AC'
        if (solicitud?.idestatusdesolicitudes == 4) estatus = 'Aceptada Por AC'
        if (solicitud?.idestatusdesolicitudes == 5) estatus = 'Devuelta al cliente para corrección'
        if (solicitud?.idestatusdesolicitudes == 6) estatus = 'Recibida corregida por el cliente'
        solicitudesEstatus.push({
            id: uuidv4(), idSolicitud: solicitud.idfc41_solicitudparabebidasconm,
            folio: solicitud.folio, tipoSolicitud: 'Solicitud para productos con mezcal', noSocio: solicitud.numerocliente,
            FechaDecreación: fecha, idlogin: solicitud.idlogin, nombreRazon: solicitud.nombrerazonsocial,
            Revisor: nombre?.[0] !== undefined ? revisor : '', estatus: estatus
        })

    })

    return (
        <Fragment>
            <Box sx={{ width: '80%', typography: 'body1', margin: 'auto', marginTop: '5%' }}>
                <TabContext value={tabSolicitudes}>
                    <Box sx={{
                        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                        textAlign: 'center', backgroundColor: '#fcfcfc',
                        boxShadow: '0 0px 16px 0px rgba(0, 0, 0, 0.3)', height: '60px', borderRadius: '8px'
                    }}>
                        <TabList onChange={handleChangeSolicitudesTab} aria-label="visible arrows tabs example" variant="scrollable" scrollButtons="auto" className='text-center'
                            TabIndicatorProps={{ style: { backgroundColor: 'transparent' } }}
                            sx={{
                                "& button": { color: '#7D9A47', fontFamily: 'Montserrat', fontWeight: 'bold' },
                                "& button:hover": { color: '#7D9A47', transform: 'scale(1.1)' },
                                "& button.Mui-selected": { backgroundColor: '#7D9A47', color: 'white', borderTopLeftRadius: 9, borderTopRightRadius: 9, borderBottomLeftRadius: 9, borderBottomRightRadius: 9 }
                            }}>
                            <Tab label="Recibida en AC" value="estatus2" />
                            <Tab label="En revisión por AC" value="estatus3" />
                            <Tab label="Aceptada por AC" value="estatus4" />
                            <Tab label="Devuelta al cliente" value="estatus5" />
                            <Tab label="Recibida corregida" value="estatus6" />
                        </TabList>
                    </Box>
                    <TabPanel value="estatus2" style={{ paddingLeft: 0, paddingRight: 0 }}>
                        <SolicitudesACComponent data={solicitudesEstatus} titulo="SOLICITUDES RECIBIDAS EN AC" setOpenModalRevisor={setOpenModalRevisor} />
                    </TabPanel>
                    <TabPanel value="estatus3" style={{ paddingLeft: 0, paddingRight: 0 }}>
                        <SolicitudesACComponent data={solicitudesEstatus} titulo="SOLICITUDES EN REVISIÓN POR AC" setOpenModalRevisor={setOpenModalRevisor} />
                    </TabPanel>
                    <TabPanel value="estatus4" style={{ paddingLeft: 0, paddingRight: 0 }}>
                        <SolicitudesACComponent data={solicitudesEstatus} titulo="SOLICITUDES ACEPTADAS POR AC" setOpenModalRevisor={setOpenModalRevisor} />
                    </TabPanel>
                    <TabPanel value="estatus5" style={{ paddingLeft: 0, paddingRight: 0 }}>
                        <SolicitudesACComponent data={solicitudesEstatus} titulo="SOLICITUDES DEVUELTAS AL CLIENTE PARA CORRECCIÓN" setOpenModalRevisor={setOpenModalRevisor} />
                    </TabPanel>
                    <TabPanel value="estatus6" style={{ paddingLeft: 0, paddingRight: 0 }}>
                        <SolicitudesACComponent data={solicitudesEstatus} titulo="SOLICITUDES RECIBIDAS CORREGIDAS POR EL CLIENTE" setOpenModalRevisor={setOpenModalRevisor} />
                    </TabPanel>
                </TabContext>
            </Box>
        </Fragment >
    )
}

export default withRouter(TabsSolicitudesAtendidasACComponent)